import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Toggletip } from '@grandvisionhq/lib-visuals';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { useDeliveryIndicator } from '../../../contexts/DeliveryIndicator/context.js';
import { useGetDeliveryEstimationMessage } from '../../../hooks/use-get-delivery-estimation-message.js';
import '@grandvisionhq/graphql';
import '../../../operations/queries/get-delivery-estimation.js';
import '../../../operations/queries/get-estimated-delivery-by-skus.js';
import '../../../operations/queries/get-shipping-methods-for-cart.js';
import '../../../state/actions.js';
import { getPreferredShippingMethod } from '../../../state/selectors.js';
import { DeliveryIndicator } from '../components/DeliveryIndicator.js';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/iris-ui';
import { DeliveryIndicatorModalContainer } from './DeliveryIndicatorModal.js';

var DeliveryIndicatorFullDateContainer = (_param)=>{
    var { items , fallbackLabel , view ='full' , hasRxLens  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "items",
        "fallbackLabel",
        "view",
        "hasRxLens"
    ]);
    const { getLabel  } = useIntl();
    const { deliveryInfo  } = useDeliveryIndicator();
    const preferredShippingMethod = useSelector(getPreferredShippingMethod);
    const { deliveryMessage , loading , error  } = useGetDeliveryEstimationMessage(items !== null && items !== void 0 ? items : [], preferredShippingMethod, hasRxLens);
    const tooltipSlot = deliveryInfo ? /*#__PURE__*/ React.createElement(DeliveryIndicatorModalContainer, null) : /*#__PURE__*/ React.createElement(Toggletip, {
        message: getLabel('products.deliveryIndicator.deliveryTooltip')
    });
    return /*#__PURE__*/ React.createElement(DeliveryIndicator, swcHelpers.extends({
        deliveryMessage: deliveryMessage,
        isLoading: loading,
        hasError: !!error,
        view: view,
        fallbackLabel: fallbackLabel,
        tooltipSlot: tooltipSlot
    }, rest));
};

export { DeliveryIndicatorFullDateContainer };
//# sourceMappingURL=DeliveryIndicatorFullDate.js.map
